export const DataStoreColumns = [
  "SR NO",
  "VARIFIED",
  "EVENT NAME",
  "COMPANY NAME",
  "WEBSITE",
  "DESCRIPTION",
  "EMPLOYEE COUNT",
  "ADDRESS",
  "GENERIC EMAIL",
  "BOOTH NUMBER",
  "FIRST NAME",
  "LAST NAME",
  "TITLE",
  "EMAIL",
  "LINKEDIN URL",
  "SOURCE URL",
  "LEADS COMMENT",
  "COMPANY COMMENT",
  "COUNTRY",
  "INDUSTRY",
  "PERSON LOCATION",
  "COMPANY PHONE",
  "DIRECT DIAL",
  "DEBOUNCING DATE",
];
